import {
  AnnualSolarReport,
  annualSolarReportSchema,
} from '@sophocles/entities/AnnualSolarReport/annualSolarReportRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { endOfDay, format, parseISO, startOfDay } from 'date-fns';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_ANNUAL_SOLAR_REPORTS = 'RECEIVE_ANNUAL_SOLAR_REPORTS';
function receiveAnnualSolarReports(json) {
  return {
    type: RECEIVE_ANNUAL_SOLAR_REPORTS,
    annualSolarReports: mapListToRecords(json, AnnualSolarReport),
  };
}

/* Request Actions */
// starter request
export const REQUEST_ANNUAL_SOLAR_REPORT = 'REQUEST_ANNUAL_SOLAR_REPORT';
function requestAnnualSolarReport(annualSolarReport_id) {
  return {
    type: REQUEST_ANNUAL_SOLAR_REPORT,
    annualSolarReport_id,
  };
}

export const REQUEST_ANNUAL_SOLAR_REPORTS_FOR_SITE_WITH_RANGE = 'REQUEST_ANNUAL_SOLAR_REPORTS_FOR_SITE_WITH_RANGE';
function requestAnnualSolarReportsForSiteWithRange(site_id, from, to) {
  return {
    type: REQUEST_ANNUAL_SOLAR_REPORTS_FOR_SITE_WITH_RANGE,
    site_id,
    from,
    to,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchAnnualSolarReport(annualSolarReport_id) {
  return dispatch => {
    dispatch(requestAnnualSolarReport(annualSolarReport_id));
    return apiClient
      .get(`/annualsolarreports/${annualSolarReport_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'annualSolarReports', annualSolarReportSchema))
      .then(json => dispatch(receiveAnnualSolarReports(json.entities.annualSolarReports)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ANNUAL_SOLAR_REPORT)));
  };
}

export function fetchAnnualSolarReportsForSiteWithRange(site_id, from, to) {
  const fromTS = startOfDay(parseISO(from));
  const toTS = endOfDay(parseISO(to));
  return dispatch => {
    dispatch(requestAnnualSolarReportsForSiteWithRange(site_id, fromTS, toTS));
    return apiClient
      .get(
        `/annualsolarreports/?limit=1000&site=${site_id}&year_end_date__gte=${format(
          fromTS,
          'yyyy-MM-dd',
        )}&year_end_date__lte=${format(toTS, 'yyyy-MM-dd')}`,
      )
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'annualSolarReports', annualSolarReportSchema))
      .then(json => dispatch(receiveAnnualSolarReports(json.entities.annualSolarReports)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ANNUAL_SOLAR_REPORTS_FOR_SITE_WITH_RANGE)));
  };
}

// expecting a siteGroup id and a moment object for endDate
export function fetchAnnualSolarReportsForSiteGroupWithEndDate(siteGroup_id, endDate) {
  return dispatch => {
    dispatch({ type: 'REQUEST_ANNUAL_SOLAR_REPORTS_FOR_SITE_GROUP_WITH_RANGE', siteGroup_id, endDate });
    return apiClient
      .get(
        `/annualsolarreports/?limit=1000&site__site_groups=${siteGroup_id}&year_end_date=${endDate}&exclude_wallscape=True`,
      )
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ANNUAL_SOLAR_REPORT)));
  };
}

/* Edit Actions */
export const EDIT_ANNUAL_SOLAR_REPORT = 'EDIT_ANNUAL_SOLAR_REPORT';
export function editAnnualSolarReport(annualSolarReport_id) {
  return {
    type: EDIT_ANNUAL_SOLAR_REPORT,
    annualSolarReport: annualSolarReport_id,
  };
}

export function patchAnnualSolarReport(annualSolarReport_id, values) {
  return dispatch => {
    dispatch(editAnnualSolarReport(annualSolarReport_id));
    return apiClient
      .patch(`/annualsolarreports/${annualSolarReport_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, annualSolarReportSchema))
      .then(json => dispatch(receiveAnnualSolarReports(json.entities.annualSolarReports)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_ANNUAL_SOLAR_REPORT)));
  };
}

/* Create Actions */
export const CREATE_ANNUAL_SOLAR_REPORT = 'CREATE_ANNUAL_SOLAR_REPORT';
function sayCreateAnnualSolarReport(values) {
  return {
    type: CREATE_ANNUAL_SOLAR_REPORT,
    values: values,
  };
}

export function createAnnualSolarReport(values) {
  return dispatch => {
    dispatch(sayCreateAnnualSolarReport(values));
    return apiClient
      .post(`/annualsolarreports/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, annualSolarReportSchema))
      .then(json => dispatch(receiveAnnualSolarReports(json.entities.annualSolarReports)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_ANNUAL_SOLAR_REPORT)));
  };
}

/* Delete Actions */
export const DELETE_ANNUAL_SOLAR_REPORT = 'DELETE_ANNUAL_SOLAR_REPORT';
function sayDeleteAnnualSolarReport(annualSolarReport_id) {
  return {
    type: DELETE_ANNUAL_SOLAR_REPORT,
    annualSolarReport: annualSolarReport_id,
  };
}

export function deleteAnnualSolarReport(annualSolarReport_id) {
  return dispatch =>
    apiClient
      .delete(`/annualsolarreports/${annualSolarReport_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteAnnualSolarReport(annualSolarReport_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_ANNUAL_SOLAR_REPORT)));
}
